
// Variables
var url = document.location.href;

// Returns trimmed version of a given string
String.prototype.trim = function () { return this.replace(/^\s+|\s+$/, ''); };

// Shows not available message (used when disabling functions for i:Create side)
function showNAMessage() {
    //if (url.indexOf("/en/") >= 0) {
    alert("This function is not available in i:Create.");
    //}
    //else {
    //    alert("Cette fonction n'est pas disponible i:Create.");
    //}
}

// Replaces single quote and returns resulting string
function repSingleQuote(str) {
    return str.replace("'", "\'");
}

function repKeyword(input, keywordOld, keywordNew) {
    return input.replace(new RegExp(keywordOld, "ig"), keywordNew);
}

// Switches the language of the page by changing the URL
function switchLanguage() {

    var str = document.location.href;
    var strLowerCase = str.toLowerCase();

    if (strLowerCase.indexOf("edit_") > -1) {
        if (strLowerCase.indexOf("/en/") >= 0) {
            alert("This function is not available in edit mode.");
        }
        else {
            alert("Cette fonction n'est pas disponible dans le mode d'Ã©dition.");
        }
    }
    else if(validateURL(strLowerCase)) {

        if (strLowerCase.indexOf("/en/") >= 0) {
            str = repKeyword(str, "/en/", "/fr/");
            document.location = str;
        }

        else if (strLowerCase.indexOf("lang=en") >= 0) {
            str = repKeyword(str, "lang=en", "lang=fr");
            document.location = str;
        }

        else if (strLowerCase.indexOf("/fr/") >= 0) {
            str = repKeyword(str, "/fr/", "/en/");

            document.location = str;
        }

        else if (strLowerCase.indexOf("lang=fr") >= 0) {
            str = repKeyword(str, "lang=fr", "lang=en");
            document.location = str;
        }

            //news
        else if (strLowerCase.indexOf("/modules/news/en") >= 0) {
            str = repKeyword(str, "/en", "/fr");
            document.location = str;
        }
        else if (strLowerCase.indexOf("/modules/news/fr") >= 0) {
            str = repKeyword(str, "/fr", "/en");
            document.location = str;
        }
            //calendar
        else if (strLowerCase.indexOf(iCreateObject.calendarUrl) >= 0 && strLowerCase.indexOf("/defaut/") >= 0) {
            str = repKeyword(str, "/defaut/", "/default/");
            document.location = str;
        }
        else if (strLowerCase.indexOf(iCreateObject.calendarUrl) >= 0 && strLowerCase.indexOf("/default/") >= 0) {
            str = repKeyword(str, "/default/", "/defaut/");
            document.location = str;
        }

        else {
            //None of these patterns match, switch to fr
            var fragment = str.indexOf("#") >= 0 ? str.substring(str.indexOf("#")) : "";
            var urlNoFragment = str.substring(0, str.indexOf("#") >= 0 ? str.indexOf("#") : str.length);
            if (str.indexOf("?") >= 0) {
                urlNoFragment += "&lang=fr";
            } else {
                urlNoFragment += "?lang=fr";
            }
            document.location = urlNoFragment + fragment;
        }
    }else{
        throwInvalidURLException(strLowerCase);
    }

}

function throwInvalidURLException(invalidURL) {
    if (invalidURL.indexOf("/en/") >= 0) {
        alert("Not allowed to open a webpage of foreign domain.");
    }
    else {
        alert("Pas autorisé à ouvrir une page web d'un domaine étranger");
    }
}

function validateURL(currenturl) {
    var url = parseURL(currenturl);
    var urlHostname = url.hostname.trim();

    if (urlHostname == '') {
        return true;
    }
    else {
        if (urlHostname.match(/[^\.]+\.[^\.]+$/)[0].toLowerCase() == iCreateObject.primaryDomain) {
            return true;
        }
        else
            return false;
    }
}

function parseURL(url) {
    var a = document.createElement('a');
    a.href = url;
    return {
        source: url,
        protocol: a.protocol.replace(':', ''),
        hostname: a.hostname,
        pathname: a.pathname,
        host: a.host,
        port: a.port,
        query: a.search
    };
}

function GotoSearch(src, obj) {
    var strSearch;
    if ($(obj).is(".mobileSearchContainer #FormSearch")) {
        strSearch = src + "?strSearch=" + escape($(".mobileSearchContainer #FormSearch .searchField").val().replace(/</g, ""));
    } else {
        strSearch = src + "?strSearch=" + escape($(".searchContainer #FormSearch .searchField").val().replace(/</g, ""));
    }
    if (document.location.href.indexOf("/fr/") >= 0 || document.location.href.indexOf("lang=fr") >= 0) {
        strSearch += "&lang=fr";
    }
    window.location.href = strSearch;
    return false;
}


// Handles autoTab functionality for fields
// pcID = Previous Control ID, ccID = Current Control ID, ncID = Next Control ID
function autoTab(event, pcID, ccID, ncID) {

    var isBack = (event.keyCode == 8);

    var pc = document.getElementById(pcID);
    var cc = document.getElementById(ccID);
    var nc = document.getElementById(ncID);

    if (isBack && cc.value.length == 0 && pc != null) {
        pc.focus();
        pc.select();
    }

    if (cc.value.length >= cc.getAttribute("maxlength") && nc != null) {
        nc.focus();
        nc.select();
    }

}

// Takes in a textbox reference, a label ID and the max # of characters that can go into the textbox
// When the input reaches the maxChars limit any further typing is 'cut-off' and the
// label (displaying the number of characters left) turns red
function Counter(textbox, label, maxChars) {

    lbl = document.getElementById(label);

    if (textbox.value.length >= maxChars) {
        lbl.style.color = 'red';
        textbox.value = (textbox.value).substring(0, maxChars);
        textbox.scrollTop = textbox.scrollHeight;
    }

    else {
        lbl.style.color = 'black';
    }

    lbl.innerHTML = maxChars - (textbox.value.length);

}

function createGUID()
{
	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'
		.replace(/[xy]/g, function(c) {
			var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
			return v.toString(16);
		});
}

function icAlert(title, htmlContent)
{
	var _myAlertId = createGUID();

	$("body").prepend("<div id='"+_myAlertId+"' title='"+title+"'>"+htmlContent+"</div>");

	$("#" + _myAlertId + "").dialog(
    {
        modal: true
    });
}

//truncate characters
function truncate(inputText, charLimit) {
    if (inputText.length > charLimit) {
        if (inputText.indexOf(' ', charLimit) >= 0) {
            inputText = inputText.substring(0, inputText.indexOf(' ', charLimit)) + "...";
        }
    }
    return inputText;
}


function insertJsScript(htmlControl, src) {
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = src;
    document.getElementsByTagName(htmlControl)[0].appendChild(script);
}

function insertJsScriptToElementById(elementId, src) {
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = src;

    document.getElementById(elementId).appendChild(script);
}

function insertStyleLink(htmlControl, src) {
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.media = 'screen';
    link.href = src;

    document.getElementsByTagName(htmlControl)[0].appendChild(link);
}